/** 问答 Feed 本地缓存 */
export interface QaFeedCacheConfig {
  version: number;
  keyPrefix: string;
  maxItems: number;
}

export const QA_FEED_CACHE = {
  version: 1,
  keyPrefix: "lf.qaFeed",
  maxItems: 300,
} as const satisfies QaFeedCacheConfig;
